import { render, staticRenderFns } from "./ReportingSettings.vue?vue&type=template&id=7e9e3e64"
import script from "./ReportingSettings.vue?vue&type=script&lang=ts"
export * from "./ReportingSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports